module.exports = __webpack_public_path__ + "media/MRI15C.8d6c1d53.mp3";